<template>
  <structure>
    <!-- <b-row class="mb-2">
      <b-col class="font-weight-bold">Enable Auto BCC</b-col>
      <b-col class="align-self-center col-auto">
        <slider-switch
          class="mr-1"
          v-bind:selected="this.$store.getters.autoBCC"
          @click="toggleAutoBCC()"
        ></slider-switch>
      </b-col>
    </b-row>-->
    <b-row class="mb-2 mt-2">
      <b-col>
        <span class="font-weight-bold">Auto BCC to</span>
      </b-col>
    </b-row>
    <b-row
      v-for="(url, index) in $store.getters.bccEmails"
      v-bind:key="`bcc-${index}`"
      class="mb-2"
    >
      <b-col>
        <b-form-input size="sm" v-bind:value="url" :disabled="true"></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-danger pointer" @click="removeBccEmail(index)">
          <svg viewBox="0 0 12 16" version="1.1" width="12" height="16" aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
            />
          </svg>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          size="sm"
          label="Ignore URL"
          style="background-color: white !important;"
          v-model="newBccEmail"
        ></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-primary pointer" @click="saveBccEmail()">+ Add</span>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col>
        <span class="font-weight-bold">Auto BCC when recipient in</span>
        <span
          v-if="!$store.getters.bccWhenRecipientInEmails.length"
          class="text-muted font-weight-light"
        >
          <br />empty list, always auto BCC
        </span>
      </b-col>
    </b-row>
    <b-row
      v-for="(url, index) in $store.getters.bccWhenRecipientInEmails"
      v-bind:key="`when-${index}`"
      class="mb-2"
    >
      <b-col>
        <b-form-input size="sm" v-bind:value="url" :disabled="true"></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-danger pointer" @click="removeBccWhenEmail(index)">
          <svg viewBox="0 0 12 16" version="1.1" width="12" height="16" aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
            />
          </svg>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          size="sm"
          label="Ignore URL"
          style="background-color: white !important;"
          v-model="newBccWhenEmail"
        ></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-primary pointer" @click="saveBccWhenEmail()">+ Add</span>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col>
        <span class="font-weight-bold">Don't BCC when recipient in</span>
        <span class="text-muted font-weight-light">
          <br />only applies to 'To:' line
        </span>
      </b-col>
    </b-row>
    <b-row
      v-for="(url, index) in $store.getters.dontBccWhenRecipientInEmails"
      v-bind:key="`ignore-${index}`"
      class="mb-2"
    >
      <b-col>
        <b-form-input size="sm" v-bind:value="url" :disabled="true"></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-danger pointer" @click="removeDontBccWhenEmail(index)">
          <svg viewBox="0 0 12 16" version="1.1" width="12" height="16" aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
            />
          </svg>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          size="sm"
          label="Ignore URL"
          style="background-color: white !important;"
          v-model="newDontBccWhenEmail"
        ></b-form-input>
      </b-col>
      <b-col class="align-self-center col-auto">
        <span class="text-primary pointer" @click="saveDontBccWhenEmail()">+ Add</span>
      </b-col>
    </b-row>
  </structure>
</template>

<script>
import Structure from "./Structure";
// import SliderSwitch from "../tools/SliderSwitch";

export default {
  name: "Email",
  components: {
    Structure
    // SliderSwitch
  },
  extends: Structure,
  data() {
    return {
      newBccEmail: "",
      newBccWhenEmail: "",
      newDontBccWhenEmail: ""
    };
  },
  methods: {
    async toggleAutoBCC() {
      this.$store.commit("toggleAutoBCC");
    },
    saveBccEmail() {
      if (this.newBccEmail === "") return;
      let emails = this.$store.getters.bccEmails;
      emails.push(this.newBccEmail);
      this.$store.commit("setBccEmails", emails);
      this.newBccEmail = "";
    },
    removeBccEmail(index) {
      let emails = this.$store.getters.bccEmails;
      emails.splice(index, 1);
      this.$store.commit("setBccEmails", emails);
    },
    saveBccWhenEmail() {
      if (this.newBccWhenEmail === "") return;
      let emails = this.$store.getters.bccWhenRecipientInEmails;
      emails.push(this.newBccWhenEmail);
      this.$store.commit("setBccWhenRecipientInEmails", emails);
      this.newBccWhenEmail = "";
    },
    removeBccWhenEmail(index) {
      let emails = this.$store.getters.bccWhenRecipientInEmails;
      emails.splice(index, 1);
      this.$store.commit("setBccWhenRecipientInEmails", emails);
    },
    saveDontBccWhenEmail() {
      if (this.newDontBccWhenEmail === "") return;
      let emails = this.$store.getters.dontBccWhenRecipientInEmails;
      emails.push(this.newDontBccWhenEmail);
      this.$store.commit("setDontBccWhenRecipientInEmails", emails);
      this.newDontBccWhenEmail = "";
    },
    removeDontBccWhenEmail(index) {
      let emails = this.$store.getters.dontBccWhenRecipientInEmails;
      emails.splice(index, 1);
      this.$store.commit("setDontBccWhenRecipientInEmails", emails);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
